import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPTimeSheet } from './model/dp-timesheet';
import { DPTimeSheetService } from './dp-timesheet.service';
import { DPProject } from './model/dp-project';
import { DPProjectService } from './dp-project.service';
import { DPMarket } from './model/dp-market';
import { Router } from '@angular/router';
import { UserService } from '../user/user.service';
import { User } from '../user/user';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';



@Component({
    templateUrl: 'dp-timesheet-detail.component.html'
})
export class DPTimeSheetDetailComponent implements OnInit {
    @Input() timesheet: DPTimeSheet;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    storedStatus: string;
    storedBillable = 0;
    isStatusFirst = true;

    isFirst: any;
    project: DPProject;
    requestedTimeSheetId: number;
    requestedProjectId: number;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    notes: string;
    currentUser: any;


    constructor(
        private toasterService: ToasterService,

        private router: Router,
        private _service: NotificationsService,
        private timesheetService: DPTimeSheetService,
        private projectService: DPProjectService,
        private route: ActivatedRoute,
        private userService: UserService) {
    }

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            const timesheet_id = params['timesheet_id'];
            this.requestedTimeSheetId = timesheet_id;
            this.navigated = true;
            this.timesheetService.getTimeSheet(this.requestedTimeSheetId)
                .then(timesheet => {
                    this.timesheet = timesheet;
                    this.notes = this.timesheet.notes;
                    this.projectService.getProject(timesheet.project_id).then(project => { this.project = project; });
                    this.storedStatus = timesheet.status;
                    this.userService.getUser(this.timesheet.user_id).then(user => {this.currentUser = user; this.currentUser.name = this.currentUser.first_name + ' ' + this.currentUser.last_name; });
                });
        });
        this.isFirst = true;
    }


    save1(timesheet: DPTimeSheet, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            if (+timesheet.hours > 999.99 || +timesheet.hours < 0) {
                this.submitting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                this.notificationContent = 'The hours must be below 999.99 and above 0';
                this.createNotification();
            } else {
                this.submitting = true;
                timesheet.notes = this.notes;
                timesheet.timesheet_id = this.timesheet.timesheet_id;
                timesheet.hours = timesheet.hours.toString();
                timesheet.billable = this.storedBillable;
                this.save(timesheet);
            }
        }
    }

    save(timesheet: DPTimeSheet) {
        this.timesheet = timesheet;
        this.timesheetService
            .updateTimeSheet(this.timesheet)
            .then(timesheet => {
                this.timesheet = timesheet;
                this.submitting = false;
                this.goBack();
            })
            .catch(error => this.errorHandler(error));

    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/projects/projectdetail', this.project.project_id]);
        }
    }


    writeNotes(insertedNotes: string) {
        this.notes = insertedNotes;
    }

    checkExistingStatus() {
        if (this.timesheet.billable == 1) {
            return true;
        }
        return false;
    }

    checkStatus() {
        if (this.isStatusFirst == true) {
            this.storedBillable = this.timesheet.billable;
            this.isStatusFirst = false;
        }

        if (this.storedBillable == 0) {
            this.storedBillable = 1;
        }
        else {
            this.storedBillable = 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-timesheet-detail.component.ts